import { useEffect, useState } from "react";
import { Save, Compass } from "lucide-react";
import { toast } from "sonner";
import { getEthos, saveEthos } from "@/lib/scoutApi";
import { extractApiError } from "@/lib/api";

export const EthosEditor = () => {
  const [value, setValue] = useState("");
  const [saved, setSaved] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getEthos().then((d) => {
      setValue(d.value);
      setSaved(d.value);
    });
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const d = await saveEthos(value);
      setSaved(d.value);
      toast.success("Ethos saved", { description: "The scout reads this on every run." });
    } catch (err) {
      toast.error(extractApiError(err, "Could not save."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="scout-ethos" className="border-t border-slate-200 pt-8">
      <div className="text-xs tracking-tight text-[var(--accent)] mb-2 flex items-center gap-2">
        <Compass className="w-3.5 h-3.5" /> Vic&apos;s Ethos
      </div>
      <p className="text-sm text-slate-500 mb-4">
        The agent reads this statement before every search. Sharpen it and the taste sharpens.
      </p>
      <textarea
        data-testid="scout-ethos-textarea"
        rows={7}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="w-full bg-white border border-slate-300 focus:border-[var(--accent)] px-4 py-3 text-sm leading-relaxed outline-none resize-y"
      />
      <button
        type="button"
        data-testid="scout-ethos-save"
        onClick={save}
        disabled={busy || value === saved || value.trim().length < 20}
        className="mt-3 inline-flex items-center gap-2 border border-[#0A192F] hover:bg-[#0A192F] hover:text-white disabled:opacity-40 px-4 py-2.5 text-sm font-medium transition-colors"
      >
        <Save className="w-4 h-4" /> {busy ? "Saving…" : "Save ethos"}
      </button>
    </section>
  );
};

export default EthosEditor;
